document.addEventListener 'DOMContentLoaded', ->
  accordions = document.getElementsByClassName('accordion-button')

  closeAll = ->
    for accordion in accordions
      accordion.classList.remove 'expanded', false
      accordion.nextElementSibling.style.maxHeight = null

  toggleAccordion = (e) ->
    contentPanel = @nextElementSibling
    if contentPanel.style.maxHeight
      contentPanel.style.maxHeight = null
      @classList.remove 'expanded'
    else
      closeAll()
      contentPanel.style.maxHeight = contentPanel.scrollHeight + 'px'
      @classList.add 'expanded'
    e.preventDefault()

  for accordion in accordions
    accordion.addEventListener 'click', toggleAccordion
    accordion.addEventListener 'touchstart', toggleAccordion
